import styled from 'styled-components';

export const NoBookingCardOuterWrap = styled.div(
    props => `
        width:100%;
        display: flex;
        padding: 10rem; 
    `
);

export const NoBkngImgWrap = styled.div(
    props => `
        width:12rem;
        height: 11.4rem;
        margin-right: ${props.theme.spacing.large.l60};
    `
);

export const NoBookingInfoText = styled.div(
    props => `
        width:805;
        display: flex;
        flex-direction: column;
    `
);

export const NoBookingHeadText = styled.p(
    props => `
        font-size: ${props.theme.font.large.font22};
        color: ${props.theme.colors.black.base};
        font-weight: ${props.theme.font.fontWeight.black};
        padding-bottom: ${props.theme.spacing.large.l15};
    `
);

export const NoBookingSubText = styled.p(
    props => `
        font-size: ${props.theme.font.large.font14};
        color: ${props.theme.colors.grey.base};
        padding-bottom: ${props.theme.spacing.large.l15};
    `
);

export const NoBookingBtnWrap = styled.div(
    props => `
        display: flex;
        padding-top: ${props.theme.spacing.large.l15};
    `
);

export const PlanTripBtn = styled.button(
    props => `
        display: flex;
        align-self: flex-end;
        outline: none;
        border: none;
        border-radius: 2.4rem;
        box-shadow: 0 3px 4px 0 rgba(0, 0, 0, 0.2);
        background-image: linear-gradient(95deg, #53b2fe 1%, #065af3 130%);
        padding: ${props.theme.spacing.large.l15} ${props.theme.spacing.large.l25};
        font-size: ${props.theme.font.large.font14};
        color: ${props.theme.colors.white.base};
        font-weight: ${props.theme.font.fontWeight.bold};
        text-transform: uppercase;
        cursor: pointer;
    `
)